import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import RegionalMap from './modules/RegionalMap';
import { StateProvider } from './state/state';
/**
 * Constants
 */
const regionalMap = document.getElementById('regional-map');
if (regionalMap) {
    ReactDOM.render(_jsx(StateProvider, { children: _jsx(RegionalMap, {}) }), regionalMap);
}
